import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FiFileText, FiCheck } from 'react-icons/fi'

import Modal from '../../../shared/modal/Modal'
import api from '../../../utils/api'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import EditGenerator from '../EditGenerator'
import GeneratorReportModal from '../GeneratorReportModal'
import useFlashMessage from '../../../hooks/useFlashMessage'
import useMyPermission from '../../../hooks/useMyPermission'

function ListGeneratorRow({ dataArray, myPermission, handleOnSelectItem, handleOnSuccess, selectItem, selectedData }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    const [modalEditGenerator, setModalEditGenerator] = useState(false)
    const [generatorId, setGeneratorId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [generatorName, setGeneratorName] = useState("")
    const [modalReport, setModalReport] = useState(false)
    const [reportItem, setReportItem] = useState(null)
    const [selectedItens, setSelectedItens] = useState(selectedData || [])

    const { checkPermission } = useMyPermission()
    const myPermissionEdit   = checkPermission(myPermission, "generator_Edit")
    const myPermissionDelete = checkPermission(myPermission, "generator_Delete")
    const myPermissionView   = checkPermission(myPermission, "generator_View")

    const isSelected = (item) => !!selectedItens.find((i) => i._id === item._id)

    const select = (item) => {
        if (!selectItem) return
        const next = isSelected(item)
            ? selectedItens.filter((i) => i._id !== item._id)
            : [...selectedItens, item]
        handleOnSelectItem(next)
        setSelectedItens(next)
    }

    async function deleteGenerator(id) {
        let msgType = 'success'
        const data = await api.delete(`/generator/delete/${id}`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((res) => {
            handleOnSuccess()
            setModalDeleteItem(false)
            return res.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
    }

    const Spec = ({ label, value }) => value ? (
        <span className="gen-item-spec">
            <span className="gen-item-spec-label">{label}</span>
            {value}
        </span>
    ) : null

    return (
        <div>
            {myPermissionView && dataArray && dataArray.map((item) => (
                <div
                    key={item._id}
                    className={[
                        'pg-item',
                        selectItem    ? 'pg-item-selectable' : '',
                        isSelected(item) ? 'pg-item-selected'   : '',
                    ].join(' ')}
                    onClick={() => select(item)}
                >
                    <div className="pg-item-main">
                        <div className="pg-item-header">
                            <span className="pg-item-name">{item.name}</span>
                            {item.disabled && (
                                <span className="pg-item-status-disabled">Desabilitado</span>
                            )}
                            {!item.linked && (
                                <span className="pg-item-status-unlinked" title="Não está vinculado a nenhum cliente">Sem cliente</span>
                            )}
                        </div>

                        <div className="gen-item-specs">
                            <Spec label="Fabricante" value={item.manufacturer} />
                            {item.manufacturer && item.engine   && <span className="gen-item-spec-sep">·</span>}
                            <Spec label="Motor"     value={item.engine} />
                            {(item.manufacturer || item.engine) && item.power && <span className="gen-item-spec-sep">·</span>}
                            <Spec label="Potência"  value={item.power} />
                            {(item.manufacturer || item.engine || item.power) && item.tankCapacity && <span className="gen-item-spec-sep">·</span>}
                            <Spec label="Tanque"    value={item.tankCapacity} />
                            {(item.manufacturer || item.engine || item.power || item.tankCapacity) && item.battery && <span className="gen-item-spec-sep">·</span>}
                            <Spec label="Bateria"   value={item.battery} />
                        </div>
                    </div>

                    {selectItem ? (
                        <div className={`pg-item-checkbox ${isSelected(item) ? 'pg-item-checkbox-checked' : ''}`}>
                            <FiCheck size={14} />
                        </div>
                    ) : (
                        <div className="shd-row-box-item-action">
                            <FiFileText
                                className="gen-icon-report"
                                title="Relatório"
                                onClick={(e) => { e.stopPropagation(); setReportItem(item); setModalReport(true) }}
                            />
                            {myPermissionEdit && (
                                <FaPencilAlt
                                    className="shd-icon-row-edit"
                                    title="Editar"
                                    onClick={(e) => { e.stopPropagation(); setGeneratorId(item._id); setModalEditGenerator(true) }}
                                />
                            )}
                            {myPermissionDelete && (
                                <FaTrashAlt
                                    className="shd-icon-row-trash"
                                    title="Apagar"
                                    onClick={(e) => { e.stopPropagation(); setModalDeleteItem(true); setGeneratorId(item._id); setGeneratorName(item.name) }}
                                />
                            )}
                        </div>
                    )}
                </div>
            ))}

            <Modal
                modalStatus={modalEditGenerator}
                changeStatus={setModalEditGenerator}
                w={82}
                content={
                    <EditGenerator
                        id={generatorId}
                        handleOnSuccess={() => { setModalEditGenerator(false); handleOnSuccess() }}
                        btCancelAction={() => setModalEditGenerator(false)}
                    />
                }
            />

            {modalReport && (
                <GeneratorReportModal
                    generator={reportItem}
                    onClose={() => setModalReport(false)}
                />
            )}

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteGenerator(generatorId)}
                message="Deseja realmente excluir esse gerador?"
                itemName={generatorName}
            />
        </div>
    )
}

export default ListGeneratorRow
